// Settings index
import mutations from './mutations';
import actions from './actions';
import getters from './getters';

export default {
  state: {
    shops: {
      items: [],
      count: '',
      entity: {},
    },
    shippingMethods: {
      items: [],
      count: '',
      entity: {},
    },
    shop: {},
    shippingMethod: {},
  },
  actions,
  mutations,
  getters,
};
